import { createContext } from 'react';

import { DevModeContextValue } from './dev-mode.type';

/**
 * The context object only. The provider lives in `dev-mode-provider.tsx` (handbook §01 §6).
 *
 * Read it through `useDevMode()` in `@hooks/use-dev-mode` — that hook is the single door into
 * dev mode. Nothing else should ask PostHog or `localStorage` whether dev mode is on, so that a
 * future feature cannot gate itself on one half of the answer and skip the flag.
 */
export const DevModeContext = createContext<DevModeContextValue>({
  isAvailable: false,
  isOn: false,
  isDevMode: false,
  toggleDevMode: () => {},
});
